/* Delivery estimator: 1 business-day handling (Mon–Fri) + 6–8 transit days (Mon–Sat). */
(function () {
  'use strict';

  function copyDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addHandlingBusinessDays(date, numberOfDays) {
    var result = copyDate(date);
    var remaining = numberOfDays;

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day >= 1 && day <= 5) {
        remaining -= 1;
      }
    }

    return result;
  }

  function addTransitDaysIncludingSaturday(date, numberOfDays) {
    var result = copyDate(date);
    var remaining = numberOfDays;

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) {
        remaining -= 1;
      }
    }

    return result;
  }

  function formatDate(date) {
    var locale = document.documentElement.lang || 'en';
    try {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).format(date);
    } catch (error) {
      return date.toLocaleDateString();
    }
  }

  function estimateDeliveryRange() {
    var dispatchDate = addHandlingBusinessDays(new Date(), 1);
    return {
      earliest: addTransitDaysIncludingSaturday(dispatchDate, 6),
      latest: addTransitDaysIncludingSaturday(dispatchDate, 8)
    };
  }

  function renderDeliveryDates() {
    var estimate = estimateDeliveryRange();
    var message = 'Estimated delivery: ' + formatDate(estimate.earliest) + ' – ' + formatDate(estimate.latest);

    document.querySelectorAll('[data-delivery-promise]').forEach(function (promise) {
      var target = promise.querySelector('[data-delivery-date]');
      if (target && target.textContent !== message) {
        target.textContent = message;
      }
      promise.classList.add('delivery-promise--ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderDeliveryDates);
  } else {
    renderDeliveryDates();
  }

  document.addEventListener('shopify:section:load', renderDeliveryDates);
  document.addEventListener('cart:refresh', renderDeliveryDates);

  /* The Warehouse cart drawer is inserted after Ajax add-to-cart requests. */
  if (document.body && window.MutationObserver) {
    var cartDeliveryObserver = new MutationObserver(function (mutations) {
      var hasNewDeliveryPromise = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-delivery-promise]') ||
            node.querySelector('[data-delivery-promise]')
          );
        });
      });

      if (hasNewDeliveryPromise) {
        renderDeliveryDates();
      }
    });

    cartDeliveryObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
